import { Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

interface CountdownProps {
  targetDate: string // ISO string format (e.g., "2025-12-31T23:59:59")
}

const Countdown: React.FC<CountdownProps> = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = new Date(targetDate).getTime() - new Date().getTime()

    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    }
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearInterval(timer)
  }, [targetDate])

  return (
    <Stack sx={{ mt: 4, p: 2, bgcolor: '#fc5', alignItems: 'center', borderRadius: 3 }}>
      <Typography variant='h6' sx={{ color: '#222' }}>
        The old license system will shut down in
      </Typography>
      <Typography variant='h1' component='h2' sx={{ color: '#222' }}>
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
      </Typography>
    </Stack>
  )
}

export default Countdown
